import type { BannerLink } from '@/shared/ui/banner-slider/banner-slider';
import { imageUrl } from './image';
import { isHttpUrl } from './url';

export type Banner = {
  id: number;
  name: string;
  imgPath: string;
  redirectUri: string | null;
  order: number;
};

export type BannerDto = {
  id: number;
  imgPath: string;
  redirectUri: string | null;
  name: string | null;
  order: number;
  position: 'TOP' | 'BOTTOM';
};

export function splitBanners(dtos: BannerDto[]): { topBanners: Banner[]; bottomBanners: Banner[] } {
  const topBanners: Banner[] = [];
  const bottomBanners: Banner[] = [];
  for (const dto of dtos) {
    const banner: Banner = {
      id: dto.id,
      name: dto.name ?? '',
      imgPath: dto.imgPath,
      redirectUri: dto.redirectUri,
      order: dto.order,
    };
    (dto.position === 'TOP' ? topBanners : bottomBanners).push(banner);
  }
  return { topBanners, bottomBanners };
}

function redirectTarget(uri: string): Pick<BannerLink, 'href' | 'to'> {
  if (isHttpUrl(uri)) return { href: uri };
  if (uri.startsWith('redirect-image')) return { to: `/detail?key=${encodeURIComponent(uri)}` };
  return {};
}

export function toBannerLinks(banners: Banner[]): BannerLink[] {
  return [...banners]
    .sort((a, b) => a.order - b.order)
    .map((banner) => {
      const target = banner.redirectUri ? redirectTarget(banner.redirectUri) : {};
      const hasLink = target.href !== undefined || target.to !== undefined;
      return {
        id: banner.id,
        src: isHttpUrl(banner.imgPath) ? banner.imgPath : imageUrl(banner.imgPath),
        alt: banner.name || (hasLink ? '배너 바로가기' : ''),
        ...target,
      };
    });
}
